module.exports = __webpack_public_path__ + "static/media/rober10.a2b2aa1b.jpg";